<template lang="pug">
div.body-lo
  div.modal-header
    span.lo-modal-title COPY THÀNH VIÊN
    span.lo-modal-btn-close.material-icons(@click="closePopup") close
  div.modal-body
    div.note Chuyển toàn bộ thành viên trong lớp học 
      span {{name}} 
      | sang các lớp còn lại của PC. Vui lòng chọn các lớp học bạn muốn các thành viên này cũng tham gia:
    div.reg-content
      .box-class-popup(v-if="classes && classes.length")
        .item-class(v-for="(item, index) in classes" v-if="item.id > 0 && Number(item.id) !== Number(id)")
          span {{item.name}}
          .item-checkbox
            input(type="checkbox" name="class_popup" :value="item.id" :id="'class_popup_' + item.id"  @click="onClickChecked(item, $event)")
            label(:for="'class_popup_' + item.id")
  div.modal-footer.lo-custom-footer
    div.row
      div.col-md-12.col-12.text-center.popup-button
        button.btn-active.btn-popup(@click="submitClass" v-if="lstClassSelected.length > 0") Lưu
        button.btn-active.btn-popup.no-action(v-else) Lưu
        button.btn-popup(@click="closePopup") Huỷ yêu cầu
</template>
<script>
export default {
  props: {
    id: 0,
    name: {
      type: String,
      default: ''
    },
    classes: Array,
    copyToClass: Function
  },
  data() {
    return {
      lstClassSelected: []
    }
  },
  methods: {
    closePopup() {
      this.$emit('close')
    },
    onClickChecked(item, event) {
      var id = Number(event.target.value)
      if (event.target.checked) this.lstClassSelected.push({id: item.id, name: item.name, type_approval: item.type_approval, private: item.private, exercise_ids: item.exercise_ids})
      else this.lstClassSelected = this.lstClassSelected.filter(key => key.id !== id)
    },
    submitClass() {
      this.copyToClass({ classSelected: this.lstClassSelected })
      if (this.lstClassSelected.length > 0) {
        this.$nextTick(() => {
          this.$emit('close')
        })
      }
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-lo {
  margin-left: 5px;
  margin-right: 5px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  .lo-modal-title {
    font-family: 'adobe-clean', sans-serif;
    float: left;
    font-size: 17px;
  }
  .lo-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .note{margin-bottom: 15px;
    span{font-weight: bold;}
  }
  .reg-content{
    .box-class-popup{
      .item-class{background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #EFEFEF; border-bottom: 0 none; padding: 5px; display: flex;
        &:last-child{border-bottom: 1px solid #EFEFEF;}
        span{display:inline-flex; color: #343A40; font-size:15px; width: calc(100% - 30px); padding-left: 10px; font-weight: normal;}
        .item-checkbox{display:inline-flex; width: 30px;justify-content: center;align-items: center;
          input{display:none;}
          input + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box_outline@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block; background-size: cover; margin: 0;}
          input:checked + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block;background-size: cover;}
        }
      }
    }
    span{color: #333333; font-size: 15px; font-weight: bold;}
  }
  .popup-button{text-align: center; margin-top: 25px; margin-bottom: 15px;
    .btn-popup{border-radius: 5px; height: 48px; font-size: 13px;background: #fff; border: 1px solid #FFD311;color: #343A40; margin: 0;width: 160px;
      &.btn-active{background: #FFD311 0% 0% no-repeat padding-box; border: 1px solid #FFD311; margin-right: 30px;}
      &.no-action{background: #ccc; border: 1px solid #ccc;}
    }
  }
  .lo-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .lo-btn-continue {
    background: var(--color-background-button);
    color: #000;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
    margin-bottom: 15px;
  }
  .lo-popup-pc{color: #23180A; font-size: 14px;}
  .lo-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .lo-custom-footer {
    padding: 0;
    border: 0;
  }
// cellphones 
@media (max-width: 414px) {
  .lo-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
  }
  .lo-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
  }
}
}
</style>



// WEBPACK FOOTER //
// popup.vue?531c715e